var nlsMessages = {
    "en_US": {
        "HISTORY" :"History",
        
        "ARTICLES" : "Articles",
        "BRAND" : "Brand",
        "CATEGORY" : "Category",
        
        "ERR_RESOLVING_SKU" : "Your selection is either incomplete or not in stock. Please be sure to supply a value for each attribute or consider a different combination of values.",
        "QUANTITY_INPUT_ERROR" : "The value in the Quantity field is invalid. Ensure the value is a positive integer and try again.",
        "QUANTITY_INPUTS_ERROR" : "The values in the Quantity fields are invalid or empty. Ensure the values are positive integers and try again.",
        "WISHLIST_ADDED" : "The item has been successfully added to your Wish List",
        "ERROR_CONTRACT_EXPIRED_GOTO_ORDER" : "The selected items cannot be added to the shopping cart because the contracts for some of the order items are no longer available. Please select the available contracts that you want to apply to your order items.",
        "MYACCOUNT_SAVEDORDERLIST_EMPTY_ADD_TO_REQ_FAIL" : "This saved order cannot be copied to the requisition list, as it is empty.  Please add one or more items to the saved order.",
        "SHOPCART_ADDED" : "The item has been successfully added to your shopping cart.",
        "PRICE" : "Price:",
        "SKU" : "SKU:",
        "PQ_PURCHASE" : "Purchase:",
        "PQ_PRICE_X" : "{0} -",
        "PQ_PRICE_X_TO_Y" : "{0} to {1} -",
        "PQ_PRICE_X_OR_MORE" : "{0} or more -",
        
        "COMPARE_ITEM_EXISTS" : "The product you are trying to add to the compare zone already exists.",
        "COMPATE_MAX_ITEMS" : "You can only compare up to 4 products.",
        "COMPAREZONE_ADDED" : "The Item has been successfully added to the compare zone.",
        
        "GENERICERR_MAINTEXT" : "The store has encountered a problem processing the last request. Please try again. If the problem persists, {0} for assistance.",
        "GENERICERR_CONTACT_US" : "contact us",
        
        "MSC_ITEMS" : "{0} item(s)",
        
        
        "DEFAULT_WISH_LIST_NAME" : "Wish List",
        "LIST_CREATED" : "Wish list successfully created.",
        "LIST_EDITED" : "Wish list name successfully changed.",
        "LIST_DELETED" : "Wish list successfully deleted.",
        "ITEM_ADDED" : "The item has been added to your wish list.",
        "ITEM_REMOVED" : "The item has been removed from your wish list.",
        "ERR_NAME_EMPTY" : "Type a name for your wish list.",
        "ERR_NAME_TOOLONG" : "Wish list name is too long.",
        "ERR_NAME_SHOPPING_LIST" : "Wish List is a reserved name for the default wish list. Choose a different name.",
        "ERR_NAME_DUPLICATE" : "A wish list already exists with the name you have chosen. Choose a different name.",
        "INVALID_NAME_SHOPPING_LIST" : "The wish list name contains invalid characters.  Provide an alphanumeric name.",
        "WISHLIST_EMAIL_SENT" : "Your e-mail has been sent.",
        "WISHLIST_MISSINGNAME" : "The Name field cannot be blank. Type your name in the Name field and try again.",
        "WISHLIST_MISSINGEMAIL" : "The E-mail address field cannot be blank. Type the e-mail address of the person to whom you are sending your wish list and try again.",
        "WISHLIST_INVALIDEMAILFORMAT" : "Invalid E-mail address format.",
        "WISHLIST_EMPTY" : "Please create a wish list before sending an email.",
        "WISHLIST_INVALIDSENDERNAME" : "The Name field contains invalid characters. Type your name in the Name field and try again.",
            
        
        "INV_STATUS_RETRIEVAL_ERROR" : "An error occurred while retrieving inventory status. Try again later. If the problem persists, contact your site administrator.",
        "INV_ATTR_UNAVAILABLE" : "{0} - unavailable",
        
        
        "CONFIGURATION" : "Configuration",
        
        
        "QC_UPDATE_SUCCESS" : "Quick checkout profile updated successfully!",
        "MYACCOUNT_ACTION_PERFORMED" : "Action performed successfully.",
        
        
        
        "ITEM_COMPONENT_QUANTITY_NAME" : "{0} x {1}",
        
        
        "ORDER_LINE_STATUS_S" : "Order Shipped",
        "ORDER_LINE_STATUS_G" : "Order Processing",
        "ORDER_LINE_STATUS_K" : "Return Associated",
        "ORDER_LINE_STATUS_V" : "Partially Shipped",
        "ORDER_LINE_STATUS_X" : "Order Cancelled",
        
        
        "ERROR_FACET_PRICE_INVALID" : "The price entered is not in a valid format.",
        
        
        "ERROR_RecipientTooLong" : "The value entered in the recipient field is too long.",
        "ERROR_FirstNameTooLong" : "The value entered in the first name field is too long.",
        "ERROR_LastNameTooLong" : "The value entered in the last name field is too long.",
        "ERROR_MiddleNameTooLong" : "The value entered in the middle name field is too long.",
        "ERROR_AddressTooLong" : "The value entered in the street address field is too long.",
        "ERROR_CityTooLong" : "The value entered in the city field is too long.",
        "ERROR_StateTooLong" : "The value entered in the state/province field is too long.",
        "ERROR_CountryTooLong" : "The value entered in the country/region field is too long.",
        "ERROR_ZipCodeTooLong" : "The value entered in the ZIP code/postal code field is too long.",
        "ERROR_EmailTooLong" : "The value entered in the email field is too long.",
        "ERROR_PhoneTooLong" : "The value entered in the phone number field is too long.",
        "ERROR_FaxTooLong" : "The value entered in the fax field is too long.",
        "ERROR_RecipientEmpty" : "The recipient field cannot be empty.",
        "ERROR_LastNameEmpty" : "The last name field cannot be empty.",
        "ERROR_MiddleNameEmpty" : "The middle name field cannot be empty.",
        "ERROR_AddressEmpty" : "The street address field cannot be empty.",
        "ERROR_CityEmpty" : "The city field cannot be empty.",
        "ERROR_StateEmpty" : "The state/province field cannot be empty.",
        "ERROR_CountryEmpty" : "The country/region field cannot be empty.",
        "ERROR_ZipCodeEmpty" : "The ZIP code/postal code field cannot be empty.",
        "ERROR_ZipCodeInvalid" : "Zip code is not valid for this country",
        "ERROR_EmailEmpty" : "The Email address field cannot be empty.",
        "ERROR_FirstNameEmpty" : "The first name field cannot be empty.",
        "ERROR_PhonenumberEmpty" : "The phone number field cannot be empty.",
        "ERROR_PhoneEmpty" : "The phone number field cannot be empty.",
        "ERROR_FaxEmpty" : "The fax field cannot be empty.",
        "ERROR_INVALIDEMAILFORMAT" : "The email entered is not in a valid format.",
        "ERROR_INVALIDPHONE" : "The phone number entered is not in a valid format.",
        "PWDREENTER_DO_NOT_MATCH" : "The passwords entered do not match.",
        "ERROR_SpecifyYear" : "A year has not been specified. Do not specify any birthday values if you prefer to keep this information confidential.",
        "ERROR_SpecifyMonth" : "A month has not been specified. Do not specify any birthday values if you prefer to keep this information confidential.",
        "ERROR_SpecifyDate" : "A date has not been specified. Do not specify any birthday values if you prefer to keep this information confidential.",
        "ERROR_InvalidDate1" : "This date is invalid for the selected month.",
        "ERROR_InvalidDate2" : "The provided birthday is invalid.",
        "ERROR_DEFAULTADDRESS" : "Your address cannot be removed. Your address book must contain at least one address.",
        "INVALID_EXPIRY_DATE" : "Invalid expiry date.",
        "ERROR_LogonIdEmpty" : "The Logon Id field cannot be empty.",
        "ERROR_PasswordEmpty" : "The password field cannot be empty.",
        "ERROR_VerifyPasswordEmpty" : "The password verify field cannot be empty.",
        "AGE_WARNING_ALERT" : "You are under the age of 13, please read our children's privacy policy before you proceed further.",
        "ERROR_DefaultOrgRegistration" : "'Default Organization' is not a valid organization name. Please choose another name.",
        
        
        "ERROR_OrgNameEmpty" : "The organization name field cannot be empty.",
        "ERROR_OrgNameTooLong" : "The value entered in the organization name field is too long.",
        "Logon_WaitingForApproval" : "Your registration request has been received.  Your account is waiting for approval. Until your account has been approved, you cannot log on.",
        "Logon_RegistrationRequired" : "Guest users are limited to browse the catalog. Please register or log in for full access to the store.",
        "ERROR_OrganizationDescription" :"The value entered in the organization description field is too long.",
        "ERROR_BusinessCategoryTooLong" :"The value entered in the business category field is too long.",
        "ERROR_SelectOrganizationTypeEmpty" :"Please select organization type.",
        "ERROR_ParentOrgNameEmpty" :"Please search and select a valid parent organization under which you want to create new organzation.",
        
        
        "ERROR_ADD2CART_BROWSE_ONLY" : "Cannot add product to shopping cart in browse only mode.",
        
        
        "ERROR_SL_RESOLVED_SKU" : "Your selection is incomplete. For each attribute, select a value.",
        "ERROR_SL_EMPTY_SL_NAME" : "Provide a name for your new requisition list.",
        "ERROR_SL_LIST_NOT_CHOSEN" : "Choose a requisition list.",
        "ERROR_GLOBALLOGIN_BUYER_SEARCH" : "An error occured while performing the search",
        "GLOBAL_LOGIN_NO_USERS_FOUND" : "No users found",
        
        "ORG_ROLES_UPDATED" : "Organization roles updated successfully.",
        "ORG_ROLES_UPDATE_NO_CHNAGE" : "No updates are made for organization roles.",
        "APPROVAL_MEMBER_GROUP_UPDATED" : "Approval Member Groups updated successfully.",
        "ORG_ENTITY_CREATED_UPDATING_ROLES" : "Organization created successfully. Updating organization roles.",
        "ORG_SUMMARY_UPDATED" : "Organization details updated successfully.",

        
        "CSR_NO_SEARCH_CRITERIA" : "No search criteria entered. Enter at least one search criteria.",
        "CSR_SUCCESS_CUSTOMER_ACCOUNT_ACCESS" : "Successfully accessed customer account.",
        "SUCCESS_ORDER_UNLOCK" : "Successfully unlocked the order.",
        "SUCCESS_ORDER_LOCK" : "Successfully locked the order.",
        "SUCCESS_ORDER_TAKE_OVER" : "Successfully taken over the lock.",
        "CUSTOMER_ACCOUNT_ENABLE_SUCCESS" : "Successfully enabled customer account.",
        "CUSTOMER_ACCOUNT_DISABLE_SUCCESS" : "Successfully disabled customer account.",
        "DISABLE_CUSTOMER_ACCOUNT" : "Disable customer account",
        "ENABLE_CUSTOMER_ACCOUNT" : "Enable customer account",
        "RESET_PASSWORD_SUCCESS" : "Password successfully reset for customer.",
        "ORDER_CANCEL_SUCCESS" : "Successfully cancelled the order.",
        "CSR_SUCCESS_NEW_GUEST_USER_CREATION" : "Successfully created new guest customer.",
        "CSR_SUCCESS_NEW_REGISTERED_USER_CREATION" : "Successfully created new registered customer.",
        "CSR_PASSWORD_EMPTY" : "CSR password field is empty.",
        "ERROR_RESET_PASSWORD_ACCESS_ACCOUNT_TO_RESET" : "Password reset failed for new registered customer. Please access customer account to reset password.",
        "PLEASE_SELECT" :"Please select",
        "CSR_SESSION_TERMINATE_WARNING_MESSAGE" : "The current session for customer: \"{0}\" will terminate. Click Yes to end the session or No to continue current session.",
        "GUEST" : "Guest",
        "CSR_PASSWORD_EMPTY_MESSAGE" : "Enter your password to continue.",
        "_ERR_PASSWORD_FAILED" :"The password that you tried is incorrect. Please try again.",
        "ORDERS_SEARCH_BILLING_OPTION" : "Billing information",
        "ORDERS_SEARCH_SHIPPING_OPTION" : "Shipping information",
        "LOCK_CUSTOMER_ORDER_CSR" : "Lock order",
        "UNLOCK_CUSTOMER_ORDER_CSR" : "Unlock order",
        "ORDER_LOCKED_ERROR_MSG" :"Cart or order \"{0}\" is locked. For more information, contact a service representative",
        "ADD_COMMENT_MESSAGE" :"Click here to add a new comment to the order.",
        "COMMENT_LENGTH_OUT_OF_RANGE" : "The comment cannot exceed 3000 characters.",
        "EMPTY_COMMENT" : "Please enter a comment to add to the order."
    }
};